import { useCallback } from 'react';
import { useSelector } from "react-redux"; 
import jsPDF from 'jspdf';
import 'jspdf-autotable'; // Import the jsPDF autoTable plugin 
import RECICLED from "components/photos/purchaseDelivery/recicled.png";
import { useGeneratePdfOnce } from "pages/hook/useGeneratePdfOnce.js";

const ReportPurchaseSendEmail = ({ dataForm, setPdfBlob }) => { 
  const headerPrinterPurchase = useSelector(
    (state) => state.loginUser.defaultticketsformat.headerPrinterPurchase
  );
   
  const formatNumber = useCallback((num) => {
    return num.toLocaleString('es-ES', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }, []);

  const formatNumberEuro = useCallback((num) => {
    return (
      num.toLocaleString('es-ES', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }) + ' €'
    );
  }, []);

  const formatNumberTN = useCallback((num) => {
    return (
      num.toLocaleString('es-ES', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }) + ' Tn'
    );
  }, []);

  const isValidPngDataURL = useCallback((value) => {
    if (typeof value !== "string") return false;
    const trimmed = value.trim();
    if (trimmed === "") return false;
    if (trimmed.includes("static/media")) return true;
    if (!trimmed.startsWith("data:image/png;base64,")) return false;
    return trimmed.length > 200;
  }, []);

  const groupTaxes = useCallback((lines) => {
    const taxGroups = [];
    lines.forEach((line) => {
      const { tax, amount, estimatedprice, discount, taxincluded } = line;
      const taxableAmount = amount * estimatedprice * (1 - discount / 100);
      if (tax !== 0 && !taxincluded && taxableAmount !== 0) {
        const taxAmount = taxableAmount * (tax / 100);
        const existingTaxGroup = taxGroups.find(
          (group) => group.taxRate === tax
        );
        if (existingTaxGroup) {
          existingTaxGroup.taxAmount += taxAmount;
        } else {
          taxGroups.push({ taxRate: tax, taxAmount });
        }
      }
    });
    return taxGroups;
  }, []);

  const getDateFormated = useCallback((getDate) => {
    const meses = [
      'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
      'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ];
    const hoy = (getDate !== null && getDate !== "") ? new Date(getDate) : new Date();
    const dia = hoy.getDate();
    const mes = meses[hoy.getMonth()];
    const año = hoy.getFullYear();
    return `${dia} de ${mes} de ${año}`;
  }, []);
   
  const generatePDF = useCallback(() => {
    if (!dataForm || !dataForm.linespurchasedelivery || dataForm.linespurchasedelivery.length === 0) {
      return;
    }
    const doc = new jsPDF({
      orientation: 'p',
      unit: 'mm',
      format: [210, 297]
    });

    const taxGroups = groupTaxes(dataForm.linespurchasedelivery);
    let numLinesPerPurchase = 15;
    let totalPurchase = 0;
    let totalTax = 0;
    let numPages = Math.ceil(
      dataForm.linespurchasedelivery.length / numLinesPerPurchase
    );
    if (numPages === 0) {
      numPages = 1;
    }
    // En tu código original siempre hacías j < 1, lo mantengo
    for (let j = 0; j < 1; j++) {
      let yOffset = 12;
      doc.addImage(RECICLED, 'PNG', 37, 4, 5, 5);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(16);
      doc.text("ALBARÁN", 150, yOffset - 4, 'left');
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(14);
      const formatted_id = dataForm.purchasenote
        .toString()
        .padStart(8, '0');
      doc.text(`${formatted_id}`, 150, yOffset + 2, 'left');

      doc.setFont('helvetica', 'bold');
      doc.setFontSize(10);

      if (headerPrinterPurchase && headerPrinterPurchase.length > 0) {
        let counter = 0;
        headerPrinterPurchase.split('\n').forEach((line) => {
          if (counter === 0) {
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(8);
          } else {
            doc.setFont('helvetica', 'normal');
            doc.setFontSize(7);
          }
          counter++;
          doc.text(line, 40, yOffset, 'center');
          yOffset += 2.5;
        });
      }

      yOffset = 38;
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(12);
      const newDate =
        dataForm.datepurchase !== undefined &&
        dataForm.datepurchase !== null &&
        dataForm.datepurchase !== ""
          ? getDateFormated(dataForm.datepurchase)
          : "";
      doc.text(`${newDate}`, 195, yOffset - 8, 'right');

      doc.setFont('helvetica', 'normal');
      doc.setFontSize(10);
      doc.text("He recibido de D.", 15, yOffset, 'left');
      doc.text("Camión nº ", 15, yOffset + 5, 'left');
      doc.text("GRNP N.º ", 77, yOffset + 5, 'left');
      doc.text("Obra ", 15, yOffset + 10, 'left');
      doc.text("Dirección ", 15, yOffset + 15, 'left');
      doc.text("E-mail ", 15, yOffset + 20, 'left');

      doc.setLineDash([0.2, 0.2], 0);
      doc.line(44, yOffset, 195, yOffset);
      doc.line(34, yOffset + 5, 75, yOffset + 5);
      doc.line(95, yOffset + 5, 195, yOffset + 5);
      doc.line(25, yOffset + 10, 195, yOffset + 10);
      doc.line(32, yOffset + 15, 195, yOffset + 15);
      doc.line(26, yOffset + 20, 195, yOffset + 20);

      doc.text(`${dataForm.ori_tras_tradename.substr(0, 78)}`, 44, yOffset - 1, 'left');
      doc.text(`${dataForm.vehiclestore_licenseplate.substr(0, 20)}`, 34, yOffset + 4, 'left');
      doc.text(`${dataForm.rel_trans_grnp.substr(0, 30)}`, 95, yOffset + 4, 'left');
      doc.text(`${dataForm.ori_tras_workplace.substr(0, 78)}`, 25, yOffset + 9, 'left');
      doc.text(`${dataForm.ori_tras_street.substr(0, 78)}`, 32, yOffset + 14, 'left');
      doc.text(`${dataForm.ori_tras_email.substr(0, 78)}`, 26, yOffset + 19, 'left');

      doc.setLineDash([]);
      doc.setFillColor('#FFFFFF');
      doc.setLineWidth(0.3);
      doc.rect(15, 60, 27, 6, 'FD');
      doc.rect(42, 60, 120, 6, 'FD');
      doc.rect(155, 60, 20, 6, 'FD');
      doc.rect(175, 60, 20, 6, 'FD');
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(6);
      doc.text("CANTIDAD/TONELADAS", 16, 64, 'left');
      doc.setFontSize(10);
      doc.text("CONCEPTO", 98, 64, 'center');
      doc.text("PRECIO", 165, 64, 'center');
      doc.text("IMPORTE", 185, 64, 'center');

      doc.setFont('helvetica', 'normal');
      doc.setFontSize(10);

      let startIndex = j * numLinesPerPurchase;
      let endIndex = Math.min(
        startIndex + numLinesPerPurchase,
        dataForm.linespurchasedelivery.length
      );
      let addyOffset = 0;
      yOffset = 68;

      for (let i = startIndex; i < endIndex; i++) {
        const line = dataForm.linespurchasedelivery[i];

        if (line.article_namees.length > 170) {
          addyOffset = 12;
        } else if (line.article_namees.length > 85) {
          addyOffset = 8;
        } else {
          addyOffset = 4;
        }

        doc.setFillColor('#FFFFFF');
        doc.setLineWidth(0.2);
        doc.rect(15, yOffset - 3, 27, addyOffset, 'FD');
        doc.rect(42, yOffset - 3, 120, addyOffset, 'FD');
        doc.rect(155, yOffset - 3, 20, addyOffset, 'FD');
        doc.rect(175, yOffset - 3, 20, addyOffset, 'FD');

        doc.setFont('helvetica', 'normal');
        doc.setFontSize(8);

        if (line.ticketweight) {
          doc.text(`${formatNumberTN(line.amount)}`, 41, yOffset, 'right');
        } else {
          doc.text(`${formatNumber(line.amount)}`, 41, yOffset, 'right');
        }

        totalPurchase +=
          line.amount *
          line.estimatedprice *
          (1 - line.discount / 100);

        if (!line.taxincluded) {
          totalTax +=
            line.amount *
            line.estimatedprice *
            (1 - line.discount / 100) *
            (line.tax / 100);
        }

        if (line.article_namees.length > 160) {
          doc.text(`${line.article_namees.substr(0, 85)}`, 43, yOffset, 'left');
          doc.text(`${line.article_namees.substr(85, 85)}`, 43, yOffset + 4, 'left');
          doc.text(`${line.article_namees.substr(170)}`, 43, yOffset + 8, 'left');
          doc.text(
            `${formatNumberEuro(line.estimatedprice * (1 - line.discount / 100))}`,
            173,
            yOffset + 8,
            'right'
          );
          doc.text(
            `${formatNumberEuro(
              line.amount *
                line.estimatedprice *
                (1 - line.discount / 100)
            )}`,
            193,
            yOffset + 8,
            'right'
          );
        } else if (line.article_namees.length > 85) {
          doc.text(`${line.article_namees.substr(0, 85)}`, 43, yOffset, 'left');
          doc.text(`${line.article_namees.substr(85)}`, 43, yOffset + 4, 'left');
          doc.text(
            `${formatNumberEuro(line.estimatedprice * (1 - line.discount / 100))}`,
            173,
            yOffset + 4,
            'right'
          );
          doc.text(
            `${formatNumberEuro(
              line.amount *
                line.estimatedprice *
                (1 - line.discount / 100)
            )}`,
            193,
            yOffset + 4,
            'right'
          );
        } else {
          doc.text(`${line.article_namees.substr(0, 85)}`, 43, yOffset, 'left');
          doc.text(
            `${formatNumberEuro(line.estimatedprice * (1 - line.discount / 100))}`,
            173,
            yOffset,
            'right'
          );
          doc.text(
            `${formatNumberEuro(
              line.amount *
                line.estimatedprice *
                (1 - line.discount / 100)
            )}`,
            193,
            yOffset,
            'right'
          );
        }

        yOffset += addyOffset;
      }

      doc.setFillColor('#FFFFFF');
      doc.setLineWidth(0.3);
      doc.line(15, yOffset - 3, 195, yOffset - 3);
      doc.rect(175, yOffset - 3, 20, 4, 'FD');
      yOffset += 4;
      doc.rect(175, yOffset - 3, 20, 4, 'FD');
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(9);
      doc.text("SUBTOTAL", 173, yOffset - 4, 'right');
      doc.text(`${formatNumberEuro(totalPurchase)}`, 193, yOffset - 4, 'right');
      yOffset += 4;

      if (taxGroups && taxGroups.length > 0) {
        taxGroups.forEach((group) => {
          doc.setFillColor('#FFFFFF');
          doc.setLineWidth(0.3);
          doc.rect(175, yOffset - 3, 20, 4, 'FD');
          doc.setFont('helvetica', 'normal');
          doc.setFontSize(9);
          doc.text(`IGIC ${group.taxRate}%:`, 173, yOffset, 'right');
          doc.text(`${formatNumberEuro(group.taxAmount)}`, 193, yOffset, 'right');
          yOffset += 4;
        });
      } else {
        doc.setFillColor('#FFFFFF');
        doc.setLineWidth(0.3);
        doc.rect(175, yOffset - 3, 20, 4, 'FD');
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(9);
        doc.text("IGIC", 173, yOffset, 'right');
        yOffset += 4;
      }

      doc.setFillColor('#FFFFFF');
      doc.setLineWidth(0.3);
      doc.rect(175, yOffset - 3, 20, 4, 'FD');
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(9);
      doc.text("TOTAL", 173, yOffset, 'right');
      const paymentData = "FORMA DE PAGO: " + dataForm.payment_namees;
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(9);
      doc.text(`${formatNumberEuro(totalPurchase + totalTax)}`, 193, yOffset, 'right');
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(9);
      doc.text(`${paymentData}`, 195, yOffset + 8, 'right');

      if (
        dataForm.ownnumberpurchase &&
        dataForm.ownnumberpurchase.trim() !== null &&
        dataForm.ownnumberpurchase.trim() !== ""
      ) {
        const referenceData =
          "Referencia Cliente: " + dataForm.ownnumberpurchase.trim();
        doc.text(`${referenceData}`, 195, yOffset + 12, 'right');
      }

      yOffset = 115;
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(8);
      doc.text("DNI nº", 82, yOffset + 16, 'left');
      doc.setLineDash([0.2, 0.2], 0);
      doc.line(92, yOffset + 16, 120, yOffset + 16);
      doc.setLineDash([]);

      if (
        dataForm.signature_dispatched_by !== undefined &&
        dataForm.signature_dispatched_by !== "" &&
        isValidPngDataURL(dataForm.signature_dispatched_by)
      ) {
        try {
          doc.addImage(
            `${dataForm.signature_dispatched_by}`,
            'PNG',
            17,
            yOffset + 2,
            20,
            20
          );
        } catch (e) {}
      }

      if (
        dataForm.signature_client !== undefined &&
        dataForm.signature_client !== "" &&
        isValidPngDataURL(dataForm.signature_client)
      ) {
        try {
          doc.addImage(
            `${dataForm.signature_client}`,
            'PNG',
            98,
            yOffset + 5,
            8,
            8
          );
        } catch (e) {}
      }

      doc.setFont('helvetica', 'normal');
      doc.setFontSize(8);
      doc.text("Despachado por", 18, yOffset + 3, 'left');
      doc.text("Conforme Cliente", 100, yOffset + 3, 'center');
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(7);
      doc.text(
        "*Este documento no tiene valor como  'Certificado Acreditativo de Gestión de Residuos de la Construcción'  según el art. 7.c. del Real Decreto 105/2008",
        12,
        yOffset + 24,
        'left'
      );
    }

    const pdfBlob = doc.output('blob');
    if (pdfBlob) {
      setPdfBlob(pdfBlob);
    }
  }, [
    dataForm,
    headerPrinterPurchase,
    formatNumber,
    formatNumberEuro,
    formatNumberTN,
    groupTaxes,
    setPdfBlob,
    getDateFormated,
    isValidPngDataURL,
  ]);

  // ------- CONDICIÓN Y HOOK PARA QUE SOLO GENERE UNA VEZ -------

  const ready =
    dataForm !== undefined &&
    dataForm !== null &&
    dataForm.id !== undefined &&
    dataForm.id !== null &&
    dataForm.id !== "" &&
    dataForm.id !== "0" &&
    dataForm.id !== 0;

  useGeneratePdfOnce(ready, generatePDF);

  return null;
};

export default ReportPurchaseSendEmail;
